const seekerInitialState = {
    //product-type
    loadingSidebarPermissionApi: true,
    sidebarPermissionDataError: "",
    sidebarPermissionData: [],

    //hrms side bar permission//
    loadingSidebarPermissionHRMSApi: true,
    sidebarPermissionHRMSDataError: "",
    sidebarPermissionHRMSData: [],

    loadingNotification: true,
    notificationDataError: "",
    notificationData: [],

    loadingCompanyDetail: true,
    CompanyDetailData: {},
    CompanyDetailDataError: '',

}

const NavbarReducer = (state = seekerInitialState, action) => {
    switch (action.type) {

        //product-type//
        case 'FIND_SIDEBAR_PERMISSION_REQUEST':
            return {
                ...state,
                loadingSidebarPermissionApi: true,
                sidebarPermissionData: "",
                sidebarPermissionDataError: '',
            };
        case 'FIND_SIDEBAR_PERMISSION_SUCCESS':
            return {
                ...state,
                loadingSidebarPermissionApi: false,
                sidebarPermissionData: action.payload,
            };
        case 'FIND_SIDEBAR_PERMISSION_FAILURE':
            return {
                ...state,
                loadingSidebarPermissionApi: false,
                sidebarPermissionDataError: action.payload,
            };
        //product-type//

        //hrms side bar permission//
        case 'FIND_SIDEBAR_PERMISSION_HRMS_REQUEST':
            return {
                ...state,
                loadingSidebarPermissionHRMSApi: true,
                sidebarPermissionHRMSData: "",
                sidebarPermissionHRMSDataError: '',
            };
        case 'FIND_SIDEBAR_PERMISSION_HRMS_SUCCESS':
            return {
                ...state,
                loadingSidebarPermissionHRMSApi: false,
                sidebarPermissionHRMSData: action.payload,
            };
        case 'FIND_SIDEBAR_PERMISSION_HRMS_FAILURE':
            return {
                ...state,
                loadingSidebarPermissionHRMSApi: false,
                sidebarPermissionHRMSDataError: action.payload,
            };
        //hrms side bar permission//

        //notification//
        case 'FIND_NOTIFICATION_REQUEST':
            return {
                ...state,
                loadingNotification: true,
                notificationData: [],
                notificationDataError: '',
            };
        case 'FIND_NOTIFICATION_SUCCESS':
            return {
                ...state,
                loadingNotification: false,
                notificationData: action.payload,
            };
        case 'FIND_NOTIFICATION_FAILURE':
            return {
                ...state,
                loadingNotification: false,
                notificationDataError: action.payload,
            };
        //notification//

        //company details//
        case 'FIND_COMPANY_DETAILS_REQUEST':
            return {
                ...state,
                loadingCompanyDetail: true,
                CompanyDetailData: {},
                CompanyDetailDataError: '',
            };
        case 'FIND_COMPANY_DETAILS_SUCCESS':
            return {
                ...state,
                loadingCompanyDetail: false,
                CompanyDetailData: action.payload,
            };
        case 'FIND_COMPANY_DETAILS_FAILURE':
            return {
                ...state,
                loadingCompanyDetail: false,
                CompanyDetailDataError: action.payload,
            };
        //company details//

        default:
            return state;
    }
}

export default NavbarReducer;